import { create } from "zustand";
import {
  PDA1061_R01Dto,
  PDA1061_R01DisplayInfo,
  PDA1061_R01SearchParams,
  defaultPDA1061_R01DisplayInfo,
} from "src/containers/PDA/PDA1061_R01/PDA1061_R01Dto";

export interface PDA1061_R01Store {
  // 상태
  stockList: PDA1061_R01Dto[];
  loading: boolean;
  searchParams: PDA1061_R01SearchParams;

  // UI 표시용 (응답값 저장, 1090과 동일 컬럼)
  displayInfo: PDA1061_R01DisplayInfo;

  // 액션
  setStockList: (stockList: PDA1061_R01Dto[]) => void;
  setLoading: (loading: boolean) => void;
  setSearchParams: (searchParams: PDA1061_R01SearchParams) => void;
  updateSearchParam: (field: keyof PDA1061_R01SearchParams, value: string) => void;
  setDisplayInfo: (info: Partial<PDA1061_R01DisplayInfo>) => void;
  reset: () => void;
}

const initialSearchParams: PDA1061_R01SearchParams = {
  scanValue: "",
  logicCenter: "WMS10",
};

/**
 * PDA1061_R01 (재고조회) 스토어
 * 재고조회 화면의 상태와 액션을 관리
 */
const usePDA1061_R01Store = create<PDA1061_R01Store>((set) => ({
  stockList: [],
  loading: false,
  searchParams: initialSearchParams,
  displayInfo: defaultPDA1061_R01DisplayInfo,

  setStockList: (stockList) => set({ stockList }),

  setLoading: (loading) => set({ loading }),

  setSearchParams: (searchParams) => set({ searchParams }),

  updateSearchParam: (field, value) =>
    set((state) => ({
      searchParams: {
        ...state.searchParams,
        [field]: value,
      },
    })),

  setDisplayInfo: (info) =>
    set((state) => ({
      displayInfo: {
        ...state.displayInfo,
        ...info,
      },
    })),

  reset: () =>
    set({
      stockList: [],
      loading: false,
      searchParams: initialSearchParams,
      displayInfo: defaultPDA1061_R01DisplayInfo,
    }),
}));

export default usePDA1061_R01Store;
